<template>
  <article class="maxpro-info">
    <h3 class="maxpro-info__title">Полезная информация</h3>
    <ul class="maxpro-info__links">
      <li v-for="item in list" :key="item.title">
        <div class="maxpro-info__header">
          <a class="maxpro-info__info-title" :href="item.link" target="_blank">{{ item.title }}</a>
          <p class="maxpro-info__desc--mobile">{{ item.description }}</p>
          <a class="maxpro-info__link" :href="item.link" target="_blank">{{ item.btn }}</a>
        </div>
        <p class="maxpro-info__desc">{{ item.description }}</p>
      </li>
    </ul>
  </article>
</template>

<script>
export default {
  name: 'Rate',
  data() {
    return {
      list: [
        {
          title: 'Программа мероприятия',
          description: 'Ознакомьтесь с полной программой мероприятия',
          btn: 'Перейти',
          link: 'https://maximumpro.axoftglobal.ru/agenda-2025'
        },
        {
          title: 'Анкета участника',
          description: 'Пройдите короткий опрос, ваше мнение очень важно для нас.\n' + 'Это займет всего пару минут вашего времени.',
          btn: 'Заполнить',
          link: `${this.$root.__AXOFT__.axGlobalUrl}/questionnaires/axoft_maximum_pro#opros-axoft-maximum-pro`
        },
        {
          title: 'Axoft Online',
          description: 'Цифровая платформа в области ИТ-дистрибуции Быстро и просто. Реально',
          btn: 'Перейти',
          link: 'https://online.axoftglobal.ru'
        },
        {
          title: 'Axoft Навигатор',
          description: 'Axoft Навигатор — удобный сервис по нормативным документам в области ИТ: \n' + 'программному обеспечению и оборудованию и информационной безопасности',
          btn: 'Перейти',
          link: 'https://navigator.axoft.ru'
        },
      ]
    }
  }
}
</script>

<style lang="sass">
@import "~@src/sass/params"

.maxpro-info
  $card: #ffffff
  $radius: 6px
  $accent: #1AB8C4

  flex-basis: 784px

  &__title
    font-size: 20px
    font-weight: 600
    margin-bottom: 32px

  &__links
    display: flex
    flex-direction: column
    gap: 24px
    list-style: none

  &__header
    display: flex
    justify-content: space-between
    gap: 15px

  &__info-title
    font-size: 16px
    font-weight: 600
    transition: color .2s

    &:hover
      color: $accent

  &__link
    font-size: 14px
    color: $accent
    transition: opacity .2s
    flex-basis: 9ch
    cursor: pointer

    &:hover
      opacity: .6

  &__desc
    font-size: 14px
    line-height: 1.45
    color: #9FA2AC
    margin-top: 4px
    max-width: 70ch

    &--mobile
      display: none

  @media (max-width: $mobile-size)
    flex-basis: unset

    &__title
      font-size: 16px
      padding-bottom: 24px
      margin-bottom: 10px
      text-align: center
      border-bottom: 1px solid #EFEFF0

    &__header
      gap: 4px
      flex-direction: column

    &__info-title
      color: $accent

    &__desc
      display: none

      &--mobile
        display: block
        font-size: 14px
        color: #9FA2AC
        margin-block: 4px 6px

    &__links
      gap: 40px

    &__link
      flex-basis: unset
</style>


// WEBPACK FOOTER //
// src/templates/pages/axoft-maximum-pro/components/maxpro-info.vue